"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TupleTypeSpecifier = exports.NamedTypeSpecifier = exports.ListTypeSpecifier = exports.IntervalTypeSpecifier = exports.Is = exports.CanConvertQuantity = exports.ConvertQuantity = exports.ConvertsToTime = exports.ConvertsToString = exports.ConvertsToRatio = exports.ConvertsToQuantity = exports.ConvertsToInteger = exports.ConvertsToDecimal = exports.ConvertsToDateTime = exports.ConvertsToDate = exports.ConvertsToBoolean = exports.Convert = exports.ToTime = exports.ToString = exports.ToRatio = exports.ToQuantity = exports.ToInteger = exports.ToDecimal = exports.ToDateTime = exports.ToDate = exports.ToConcept = exports.ToBoolean = exports.As = void 0;
var expression_1 = require("./expression");
var datetime_1 = require("../datatypes/datetime");
var clinical_1 = require("../datatypes/clinical");
var quantity_1 = require("../datatypes/quantity");
var math_1 = require("../util/math");
var util_1 = require("../util/util");
var ratio_1 = require("../datatypes/ratio");
var uncertainty_1 = require("../datatypes/uncertainty");
// TODO: Casting and Conversion needs unit tests!
var As = /** @class */ (function (_super) {
    __extends(As, _super);
    function As(json) {
        var _this = _super.call(this, json) || this;
        if (json.asTypeSpecifier) {
            _this.asTypeSpecifier = json.asTypeSpecifier;
        }
        else if (json.asType) {
            // convert it to a NamedTypedSpecifier
            _this.asTypeSpecifier = {
                name: json.asType,
                type: 'NamedTypeSpecifier'
            };
        }
        _this.strict = json.strict != null ? json.strict : false;
        return _this;
    }
    As.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        // If it is null, return null
        if (arg == null) {
            return null;
        }
        if (ctx.matchesTypeSpecifier(arg, this.asTypeSpecifier)) {
            // TODO: request patient source to change type identification
            return arg;
        }
        else if (this.strict) {
            var argTypeString = specifierToString(guessSpecifierType(arg));
            var asTypeString = specifierToString(this.asTypeSpecifier);
            throw new Error("Cannot cast ".concat(argTypeString, " as ").concat(asTypeString));
        }
        else {
            return null;
        }
    };
    return As;
}(expression_1.Expression));
exports.As = As;
var ToBoolean = /** @class */ (function (_super) {
    __extends(ToBoolean, _super);
    function ToBoolean(json) {
        return _super.call(this, json) || this;
    }
    ToBoolean.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            var strArg = arg.toString().toLowerCase();
            if (['true', 't', 'yes', 'y', '1'].includes(strArg)) {
                return true;
            }
            else if (['false', 'f', 'no', 'n', '0'].includes(strArg)) {
                return false;
            }
        }
        return null;
    };
    return ToBoolean;
}(expression_1.Expression));
exports.ToBoolean = ToBoolean;
var ToConcept = /** @class */ (function (_super) {
    __extends(ToConcept, _super);
    function ToConcept(json) {
        return _super.call(this, json) || this;
    }
    ToConcept.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            return new clinical_1.Concept([arg], arg.display);
        }
        else {
            return null;
        }
    };
    return ToConcept;
}(expression_1.Expression));
exports.ToConcept = ToConcept;
var ToDate = /** @class */ (function (_super) {
    __extends(ToDate, _super);
    function ToDate(json) {
        return _super.call(this, json) || this;
    }
    ToDate.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        else if (arg.isDateTime) {
            return arg.getDate();
        }
        else {
            return datetime_1.Date.parse(arg.toString());
        }
    };
    return ToDate;
}(expression_1.Expression));
exports.ToDate = ToDate;
var ToDateTime = /** @class */ (function (_super) {
    __extends(ToDateTime, _super);
    function ToDateTime(json) {
        return _super.call(this, json) || this;
    }
    ToDateTime.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        else if (arg.isDate) {
            return arg.getDateTime();
        }
        else {
            return datetime_1.DateTime.parse(arg.toString());
        }
    };
    return ToDateTime;
}(expression_1.Expression));
exports.ToDateTime = ToDateTime;
var ToDecimal = /** @class */ (function (_super) {
    __extends(ToDecimal, _super);
    function ToDecimal(json) {
        return _super.call(this, json) || this;
    }
    ToDecimal.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            if (arg.isUncertainty) {
                var low = (0, math_1.limitDecimalPrecision)(parseFloat(arg.low.toString()));
                var high = (0, math_1.limitDecimalPrecision)(parseFloat(arg.high.toString()));
                return new uncertainty_1.Uncertainty(low, high);
            }
            else {
                var decimal = (0, math_1.limitDecimalPrecision)(parseFloat(arg.toString()));
                if ((0, math_1.isValidDecimal)(decimal)) {
                    return decimal;
                }
            }
        }
        return null;
    };
    return ToDecimal;
}(expression_1.Expression));
exports.ToDecimal = ToDecimal;
var ToInteger = /** @class */ (function (_super) {
    __extends(ToInteger, _super);
    function ToInteger(json) {
        return _super.call(this, json) || this;
    }
    ToInteger.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (typeof arg === 'string') {
            var integer = parseInt(arg);
            if ((0, math_1.isValidInteger)(integer)) {
                return integer;
            }
        }
        else if (typeof arg === 'boolean') {
            return arg ? 1 : 0;
        }
        return null;
    };
    return ToInteger;
}(expression_1.Expression));
exports.ToInteger = ToInteger;
var ToQuantity = /** @class */ (function (_super) {
    __extends(ToQuantity, _super);
    function ToQuantity(json) {
        return _super.call(this, json) || this;
    }
    ToQuantity.prototype.exec = function (ctx) {
        return this.convertValue(this.execArgs(ctx));
    };
    ToQuantity.prototype.convertValue = function (val) {
        if (val == null) {
            return null;
        }
        else if (typeof val === 'number') {
            return new quantity_1.Quantity(val, '1');
        }
        else if (val.isRatio) {
            // numerator and denominator are guaranteed non-null
            return val.numerator.dividedBy(val.denominator);
        }
        else if (val.isUncertainty) {
            return new uncertainty_1.Uncertainty(this.convertValue(val.low), this.convertValue(val.high));
        }
        else {
            // it's a string or something else we'll try to parse as a string
            return (0, quantity_1.parseQuantity)(val.toString());
        }
    };
    return ToQuantity;
}(expression_1.Expression));
exports.ToQuantity = ToQuantity;
var ToRatio = /** @class */ (function (_super) {
    __extends(ToRatio, _super);
    function ToRatio(json) {
        return _super.call(this, json) || this;
    }
    ToRatio.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            // Argument will be of form '<quantity>:<quantity>'
            var denominator = void 0, numerator = void 0;
            try {
                // String will be split into an array. Numerator will be at index 1, Denominator will be at index 4
                var splitRatioString = arg
                    .toString()
                    .match(/^(\d+(\.\d+)?\s*('.+')?)\s*:\s*(\d+(\.\d+)?\s*('.+')?)$/);
                if (splitRatioString == null) {
                    return null;
                }
                numerator = (0, quantity_1.parseQuantity)(splitRatioString[1]);
                denominator = (0, quantity_1.parseQuantity)(splitRatioString[4]);
            }
            catch (error) {
                // If the input string is not formatted correctly, or cannot be
                // interpreted as a valid Quantity value, the result is null.
                return null;
            }
            // The value element of a Quantity must be present.
            if (numerator == null || denominator == null) {
                return null;
            }
            return new ratio_1.Ratio(numerator, denominator);
        }
        else {
            return null;
        }
    };
    return ToRatio;
}(expression_1.Expression));
exports.ToRatio = ToRatio;
var ToString = /** @class */ (function (_super) {
    __extends(ToString, _super);
    function ToString(json) {
        return _super.call(this, json) || this;
    }
    ToString.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            return arg.toString();
        }
        else {
            return null;
        }
    };
    return ToString;
}(expression_1.Expression));
exports.ToString = ToString;
var ToTime = /** @class */ (function (_super) {
    __extends(ToTime, _super);
    function ToTime(json) {
        return _super.call(this, json) || this;
    }
    ToTime.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            var timeString = arg.toString();
            // Return null if string doesn't represent a valid ISO-8601 Time
            // hh:mm:ss.fff or hh:mm:ss.fff
            var matches = /^T?((\d{2})(:(\d{2})(:(\d{2})(\.(\d+))?)?)?)?(Z|(([+-])(\d{2})(:?(\d{2}))?))?$/.exec(timeString);
            if (matches == null) {
                return null;
            }
            var hours = matches[2];
            var minutes = matches[4];
            var seconds = matches[6];
            // Validate h/m/s if they exist, but allow null
            if (hours != null) {
                if (hours < 0 || hours > 23) {
                    return null;
                }
                hours = parseInt(hours, 10);
            }
            if (minutes != null) {
                if (minutes < 0 || minutes > 59) {
                    return null;
                }
                minutes = parseInt(minutes, 10);
            }
            if (seconds != null) {
                if (seconds < 0 || seconds > 59) {
                    return null;
                }
                seconds = parseInt(seconds, 10);
            }
            var milliseconds = matches[8];
            if (milliseconds != null) {
                milliseconds = parseInt((0, util_1.normalizeMillisecondsField)(milliseconds));
            }
            // Time is implemented as Datetime with year 0, month 1, day 1 and null timezoneOffset
            return new datetime_1.DateTime(0, 1, 1, hours, minutes, seconds, milliseconds, null);
        }
        else {
            return null;
        }
    };
    return ToTime;
}(expression_1.Expression));
exports.ToTime = ToTime;
var Convert = /** @class */ (function (_super) {
    __extends(Convert, _super);
    function Convert(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        _this.toType = json.toType;
        return _this;
    }
    Convert.prototype.exec = function (ctx) {
        switch (this.toType) {
            case '{urn:hl7-org:elm-types:r1}Boolean':
                return new ToBoolean({ type: 'ToBoolean', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}Concept':
                return new ToConcept({ type: 'ToConcept', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}Decimal':
                return new ToDecimal({ type: 'ToDecimal', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}Integer':
                return new ToInteger({ type: 'ToInteger', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}String':
                return new ToString({ type: 'ToString', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}Quantity':
                return new ToQuantity({ type: 'ToQuantity', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}DateTime':
                return new ToDateTime({ type: 'ToDateTime', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}Date':
                return new ToDate({ type: 'ToDate', operand: this.operand }).execute(ctx);
            case '{urn:hl7-org:elm-types:r1}Time':
                return new ToTime({ type: 'ToTime', operand: this.operand }).execute(ctx);
            default:
                return this.execArgs(ctx);
        }
    };
    return Convert;
}(expression_1.Expression));
exports.Convert = Convert;
var ConvertsToBoolean = /** @class */ (function (_super) {
    __extends(ConvertsToBoolean, _super);
    function ConvertsToBoolean(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToBoolean.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToBoolean, this.operand, ctx);
        }
    };
    return ConvertsToBoolean;
}(expression_1.Expression));
exports.ConvertsToBoolean = ConvertsToBoolean;
var ConvertsToDate = /** @class */ (function (_super) {
    __extends(ConvertsToDate, _super);
    function ConvertsToDate(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToDate.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToDate, this.operand, ctx);
        }
    };
    return ConvertsToDate;
}(expression_1.Expression));
exports.ConvertsToDate = ConvertsToDate;
var ConvertsToDateTime = /** @class */ (function (_super) {
    __extends(ConvertsToDateTime, _super);
    function ConvertsToDateTime(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToDateTime.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToDateTime, this.operand, ctx);
        }
    };
    return ConvertsToDateTime;
}(expression_1.Expression));
exports.ConvertsToDateTime = ConvertsToDateTime;
var ConvertsToDecimal = /** @class */ (function (_super) {
    __extends(ConvertsToDecimal, _super);
    function ConvertsToDecimal(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToDecimal.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToDecimal, this.operand, ctx);
        }
    };
    return ConvertsToDecimal;
}(expression_1.Expression));
exports.ConvertsToDecimal = ConvertsToDecimal;
var ConvertsToInteger = /** @class */ (function (_super) {
    __extends(ConvertsToInteger, _super);
    function ConvertsToInteger(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToInteger.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToInteger, this.operand, ctx);
        }
    };
    return ConvertsToInteger;
}(expression_1.Expression));
exports.ConvertsToInteger = ConvertsToInteger;
var ConvertsToQuantity = /** @class */ (function (_super) {
    __extends(ConvertsToQuantity, _super);
    function ConvertsToQuantity(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToQuantity.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToQuantity, this.operand, ctx);
        }
    };
    return ConvertsToQuantity;
}(expression_1.Expression));
exports.ConvertsToQuantity = ConvertsToQuantity;
var ConvertsToRatio = /** @class */ (function (_super) {
    __extends(ConvertsToRatio, _super);
    function ConvertsToRatio(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToRatio.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToRatio, this.operand, ctx);
        }
    };
    return ConvertsToRatio;
}(expression_1.Expression));
exports.ConvertsToRatio = ConvertsToRatio;
var ConvertsToString = /** @class */ (function (_super) {
    __extends(ConvertsToString, _super);
    function ConvertsToString(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToString.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToString, this.operand, ctx);
        }
    };
    return ConvertsToString;
}(expression_1.Expression));
exports.ConvertsToString = ConvertsToString;
var ConvertsToTime = /** @class */ (function (_super) {
    __extends(ConvertsToTime, _super);
    function ConvertsToTime(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToTime.prototype.exec = function (ctx) {
        var operatorValue = this.execArgs(ctx);
        if (operatorValue === null) {
            return null;
        }
        else {
            return canConvertToType(ToTime, this.operand, ctx);
        }
    };
    return ConvertsToTime;
}(expression_1.Expression));
exports.ConvertsToTime = ConvertsToTime;
function canConvertToType(toFunction, operand, ctx) {
    try {
        var value = new toFunction({ type: toFunction.name, operand: operand }).execute(ctx);
        if (value != null) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (error) {
        return false;
    }
}
var ConvertQuantity = /** @class */ (function (_super) {
    __extends(ConvertQuantity, _super);
    function ConvertQuantity(json) {
        return _super.call(this, json) || this;
    }
    ConvertQuantity.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), quantity = _a[0], newUnit = _a[1];
        if (quantity != null && newUnit != null) {
            try {
                return quantity.convertUnit(newUnit);
            }
            catch (error) {
                // Cannot convert input to target unit, spec says to return null
                return null;
            }
        }
    };
    return ConvertQuantity;
}(expression_1.Expression));
exports.ConvertQuantity = ConvertQuantity;
var CanConvertQuantity = /** @class */ (function (_super) {
    __extends(CanConvertQuantity, _super);
    function CanConvertQuantity(json) {
        return _super.call(this, json) || this;
    }
    CanConvertQuantity.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), quantity = _a[0], newUnit = _a[1];
        if (quantity != null && newUnit != null) {
            try {
                quantity.convertUnit(newUnit);
                return true;
            }
            catch (error) {
                return false;
            }
        }
        return null;
    };
    return CanConvertQuantity;
}(expression_1.Expression));
exports.CanConvertQuantity = CanConvertQuantity;
var Is = /** @class */ (function (_super) {
    __extends(Is, _super);
    function Is(json) {
        var _this = _super.call(this, json) || this;
        if (json.isTypeSpecifier) {
            _this.isTypeSpecifier = json.isTypeSpecifier;
        }
        else if (json.isType) {
            // Convert it to a NamedTypeSpecifier
            _this.isTypeSpecifier = {
                name: json.isType,
                type: 'NamedTypeSpecifier'
            };
        }
        return _this;
    }
    Is.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg === null) {
            return false;
        }
        if (typeof arg._is !== 'function' && !isSystemType(this.isTypeSpecifier)) {
            // We need an _is implementation in order to check non System types
            throw new Error("Patient Source does not support Is operation for localId: ".concat(this.localId));
        }
        return ctx.matchesTypeSpecifier(arg, this.isTypeSpecifier);
    };
    return Is;
}(expression_1.Expression));
exports.Is = Is;
function isSystemType(spec) {
    switch (spec.type) {
        case 'NamedTypeSpecifier':
            return spec.name.startsWith('{urn:hl7-org:elm-types:r1}');
        case 'ListTypeSpecifier':
            return isSystemType(spec.elementType);
        case 'TupleTypeSpecifier':
            return spec.element.every(function (e) { return isSystemType(e.elementType); });
        case 'IntervalTypeSpecifier':
            return isSystemType(spec.pointType);
        case 'ChoiceTypeSpecifier':
            return spec.choice.every(function (c) { return isSystemType(c); });
        default:
            return false;
    }
}
function specifierToString(spec) {
    if (typeof spec === 'string') {
        return spec;
    }
    else if (spec == null || spec.type == null) {
        return '';
    }
    switch (spec.type) {
        case 'NamedTypeSpecifier':
            return spec.name;
        case 'ListTypeSpecifier':
            return "List<".concat(specifierToString(spec.elementType), ">");
        case 'TupleTypeSpecifier':
            return "Tuple<".concat(spec.element
                .map(function (e) { return "".concat(e.name, " ").concat(specifierToString(e.elementType)); })
                .join(', '), ">");
        case 'IntervalTypeSpecifier':
            return "Interval<".concat(specifierToString(spec.pointType), ">");
        case 'ChoiceTypeSpecifier':
            return "Choice<".concat(spec.choice.map(function (c) { return specifierToString(c); }).join(', '), ">");
        default:
            return JSON.stringify(spec);
    }
}
function guessSpecifierType(val) {
    if (val == null) {
        return 'Null';
    }
    var typeHierarchy = typeof val._typeHierarchy === 'function' && val._typeHierarchy();
    if (typeHierarchy && typeHierarchy.length > 0) {
        return typeHierarchy[0];
    }
    else if (typeof val === 'boolean') {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Boolean' };
    }
    else if (typeof val === 'number' && Math.floor(val) === val) {
        // it could still be a decimal, but we have to just take our best guess!
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Integer' };
    }
    else if (typeof val === 'number') {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Decimal' };
    }
    else if (typeof val === 'string') {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}String' };
    }
    else if (val.isConcept) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Concept' };
    }
    else if (val.isCode) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Code' };
    }
    else if (val.isDate) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Date' };
    }
    else if (val.isTime && val.isTime()) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Time' };
    }
    else if (val.isDateTime) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}DateTime' };
    }
    else if (val.isQuantity) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}DateTime' };
    }
    else if (Array.isArray(val)) {
        // Get unique types from the array (by converting to string and putting in a Set)
        var typesAsStrings = Array.from(new Set(val.map(function (v) { return JSON.stringify(guessSpecifierType(v)); })));
        var types = typesAsStrings.map(function (ts) { return (/^{/.test(ts) ? JSON.parse(ts) : ts); });
        return {
            type: 'ListTypeSpecifier',
            elementType: types.length == 1 ? types[0] : { type: 'ChoiceTypeSpecifier', choice: types }
        };
    }
    else if (val.isInterval) {
        return {
            type: 'IntervalTypeSpecifier',
            pointType: val.pointType
        };
    }
    else if (typeof val === 'object' && Object.keys(val).length > 0) {
        return {
            type: 'TupleTypeSpecifier',
            element: Object.keys(val).map(function (k) { return ({ name: k, elementType: guessSpecifierType(val[k]) }); })
        };
    }
    return 'Unknown';
}
var IntervalTypeSpecifier = /** @class */ (function (_super) {
    __extends(IntervalTypeSpecifier, _super);
    function IntervalTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IntervalTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.IntervalTypeSpecifier = IntervalTypeSpecifier;
var ListTypeSpecifier = /** @class */ (function (_super) {
    __extends(ListTypeSpecifier, _super);
    function ListTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ListTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.ListTypeSpecifier = ListTypeSpecifier;
var NamedTypeSpecifier = /** @class */ (function (_super) {
    __extends(NamedTypeSpecifier, _super);
    function NamedTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NamedTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.NamedTypeSpecifier = NamedTypeSpecifier;
var TupleTypeSpecifier = /** @class */ (function (_super) {
    __extends(TupleTypeSpecifier, _super);
    function TupleTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TupleTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.TupleTypeSpecifier = TupleTypeSpecifier;
//# sourceMappingURL=type.js.map